<template>
  <div class="sim">
    <ul>
      <div>
        <div class="row">
          <div class="lmax col-lg-4 order-lg-1">
            <simenter></simenter>
            <lineup></lineup>
          </div>
          <div class="rmin col-lg-8 order-lg-2">
            <ul class="tabs">
              <li v-on:click="Tabchange('sim')" class="left" v-bind:class="{'active': TabActive === 'sim'}"><img src="../assets/seacher.svg" width="15" height="15">成績検索</li>
              <li v-on:click="Tabchange('res')" class="right" v-bind:class="{'active': TabActive === 'res', 'disable': result_sim.gamelen == 0}"><img src="../assets/chart.svg" width="15" height="15">結果表示({{result_sim.gamelen}}試合×{{result_sim.yearlen}}年)</li>
            </ul>
            <div style="line-height: 0.2em">&nbsp;</div>
            <div v-if="TabActive == 'sim'">
              <nameinput></nameinput>
            </div>
            <div v-else-if="TabActive == 'res'">
              <simscreen></simscreen>
            </div>
          </div>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
//player_record_batter_year3.json
import { mapState } from 'vuex'
const liteflag = true;

import pusers from '../assets/player_record_batter_year3.json';
import tusers from '../assets/player_record_batter_year_team3.json';
import lusers from '../assets/player_record_batter_year_leag3.json';

import nameinput from './nameinput.vue'
import simenter from './simenter.vue'
import simscreen from './simscreen.vue'
import lineup from './lineup.vue'
import Mixin from '../mixins/utility'
export default {
  name: 'index',
  components: {
    nameinput,
    lineup,
    simscreen,
    simenter,
  },
  mixins: [Mixin],
  data () {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  },
  created: function () {
    this.PageLoads()
  },
  methods: {
    Tabchange (num) {
      if(num == 'res' && this.result_sim.gamelen == 0)return false
      
      this.$store.commit('updateValue', {vals: num, keyname: 'TabActive'})
    },
    handleResize: function() {
      // resizeのたびにこいつが発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    async PageLoads () {
      await this.onLoad()
    },
    async onLoad () {
      var list = [], ntlist = {}, 
      cr = this.calcRecord, pa = this.printAVG, tid = this.teamID
      let userlist = [];
      this.CateList.some(ltp =>{
        ntlist[ltp] = {'nen': {}, 'team': {}}
        let usrs = (ltp =='選手'?pusers:ltp=='球団'?tusers:lusers);
        console.log(usrs)
        usrs.forEach(function (player, i) {
          setUser(player, i, false)
          function setUser (p, index, plus) {
            p['AVG'] = pa(cr('AVG', p), 3)
            p['SLG'] = pa(cr('SLG', p), 3)
            p['OBP'] = pa(p['OBP'], 3)
            p['OPS'] = pa(Number(p['SLG']) + Number(p['OBP']), 3)
            
            p['category'] = ltp
            const team = tid(p.team)
            
            if(plus == false)if(ltp=='選手') {
              p.name = p.r_name;
            }else{
              if(ltp=='リーグ') {
                if(p["投"]){
                  p.name = p.team.slice(0, 1) + '/投手'
                }else{
                  p.name = p.team.slice(0, 1) + '/野手'
                }
              }else{
                p.name = p.team
              }
              p.id = team
            }
            p.index = index + userlist.length
            // name += '/' + p.nen
            if (list.indexOf(name) <= -1) list.push(name);
            
            //if(Number(p.nen) >= 1950){
            function NT_Input(nt, param, subpara) {
              if(param in ntlist[ltp][nt] === false) {
                ntlist[ltp][nt][param] = {name: param, list: [], max: null}
              }
              let toobj = ntlist[ltp][nt][param]
              if(toobj.list.indexOf(subpara) <= -1)toobj.list.push(subpara)
              if(subpara > toobj.max || toobj.max == null)toobj.max = subpara;
            }
            if(ltp != '球団') {
              NT_Input('nen', p.nen, team);
              NT_Input('nen', 'ALL', team);
              NT_Input('team', team, p.nen);
              NT_Input('team', 'ALL', p.nen);
            }
          }
        })
        Object.keys(ntlist[ltp]).some(nt =>{
          Object.values(ntlist[ltp][nt]).some(kobetu => {
            kobetu.list.unshift('ALL')
            kobetu.list.sort(function(a,b){
              if(b == 'ALL')return 1
              if(nt == 'nen'){
                if(ntlist[ltp]['team'][a].max < ntlist[ltp]['team'][b].max)return 1;
                if(ntlist[ltp]['team'][a].max > ntlist[ltp]['team'][b].max)return -1;
              }
              if( a < b ) return (nt == 'team' ? 1 : -1);
              if( a > b ) return (nt == 'team' ? -1 : 1);
              return 0;
            });
          })
        })
        userlist = userlist.concat(usrs)
      })
      console.log(ntlist);
      const nownen = 2021;
      this.$store.dispatch('setValue', {vals: list, keyname: 'suggestionList'})
      this.$store.dispatch('setValue', {vals: ntlist, keyname: 'InputNTList'})
      this.$store.dispatch('setValue', {vals: userlist, keyname: 'users'})
      
      this.$store.dispatch('setValue', {vals: [], keyname: 'result_players'});
      let lu = []
      for(let d = 0;d < 9; d=(d+1)|0)lu.push(this.EmptyPlayer(d));
      this.$store.dispatch('setValue', {vals: lu, keyname: 'LineUp'})
      function getrand (r) {return Math.floor(Math.random() * r )};
      
      const rn = (liteflag ? nownen : (nownen - getrand(10))).toString();
      const tlist = ntlist['選手']['nen'][rn].list
      let rt = tlist[getrand(tlist.length - 1) + 1]//'ALL'は除外
      if(rn <= 2004 && rt == "東北楽天")rt = "近鉄";
      this.$store.dispatch('setValue', {vals: '選手', keyname: 'inputCategory'});
      this.$store.dispatch('setValue', {vals: rt, keyname: 'inputTeam'});
      this.$store.dispatch('setValue', {vals: rn, keyname: 'inputYear'});
      this.TeamInputLineUp(rt, rn);
      if(liteflag)this.$store.dispatch('setValue', {vals: '打線シミュレーターlite', keyname: 'AppTitle'});

      this.$store.dispatch('setValue', {
        vals: {
          SHuse: true,
          SHsecTop: true,
        }
      , keyname: 'LineUpSetting'})

      let filter = {}
      this.FilterRecordList.some(r =>{
        if(r != 'name')filter[r] = ['', '']
      })
      this.$store.dispatch('setValue', {vals: filter, keyname: 'SeachFilter'})
      //SeachFilter
      //this.seachName('', [rt], [rn], ['選手']);
    },
  },
  mounted: function () {

    const title = this.AppTitle
    document.title = title

    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



.sim {
  min-width: 1360px;
}
.lmax {
  max-width: 50%;
}
.rmin {
  min-width: 700px;
}
ul{
  margin: 0;
  padding: 0;
}
li{
  list-style: none;
}
.tabs {
  overflow: hidden;
}
.tabs li,
.tabs label {
  min-width: 160px;
  float: left;
  padding: 10px 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: .3s;
  border-color: #20575e; /*タブ*/
}
.tabs li.left {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.tabs li.right {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.tabs li:not(:first-child),
.tabs label:not(:first-of-type) {
  border-left: none;
}
.tabs li.active,
.tabs :checked + label {
  background-color: #e4eb96;/*tabの色*/
  cursor: auto;
}
.tabs li.disable {
  background-color: #ebebeb;
  color: #808080;
  cursor: auto;
}
.contents{
  overflow: hidden;
  margin-top: -1px;
}
.contents li {
  padding: 20px;
  border: 1px solid #ccc;
}

.jquery .contents li{
  display: none;
}
.jquery .contents li.active {
  display: block;
}
li.active {
  fill: black;
}
.tabbox {
 padding: 2px;
 background-color: #fff; /* 背景色 */
}
</style>
<style>
@import url('https://fonts.googleapis.com/css?family=Abel&display=swap');
</style>
<style>
.card-header {
  background-color: #0c586a;
  padding-bottom: 0px;
  vertical-align: text-bottom;
}
.card-title {
  color: #dae0e0;
}
.card-body {
  padding: 1%;
  background-color: #f7f9fa;
  padding-bottom: 0px;
}
* {
  text-align: justify;
}

.table_row {
  font-size: 0.95em;
font-family: 'Abel', sans-serif;
}
.table_name {
    font-size: 0.95em;
}
.fullview {
  width: 100%;
  height: 100%;
  background: #fefefe;
  position: fixed;
  top: 0;
  left: 0;
}
.loading-spacer {
  height: 30%;
}
.headline {
  font-size: 1.05em;
  background: linear-gradient(transparent 65%, #dedc6a 70%);
}
.underline_link {
  position: relative;
  display: inline-block;
  text-decoration: none;
}
.underline_link:hover::after {
  border-bottom: solid 2px white;
  transform: scale(1, 1);
}
.underline_link::after {
  position: absolute;
  bottom: +0px;
  left: 0;
  content: '';
  width: 100%;
  height: 2px;
  background: white;
  transform: scale(0, 1);
  transform-origin: left top;
  transition: transform .15s;
}
.filterbox{
    padding: 0.0em 0.5em 0.0em;
    margin: 0.1em 0;
    color: #606266;/*文字色*/
    background: #FFF;
    border: solid 2px #606266;/*線*/
    border-radius: 6px;/*角の丸み*/
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue